import React, { memo } from 'react';

const SubstringComponent = ({ data, value }) => {
  if (!data) return <span />;

  return value ? <span>{`${value.substr(5, 2)}/${value.substr(8, 2)}/${value.substr(0, 4)}`}</span> : null;
};

export const Substring = memo(SubstringComponent);
